/* @generated from adl module ferovinum.sourcecontracts.dealterms */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.deal_terms` contract.
 */
export interface DealTermsSource {
  id: ferovinum_app_db.DealTermsId;
  generalHeader: (common_strings.StringNE|null);
  generalContent: (common_strings.StringNE|null);
  fspHeader: (common_strings.StringNE|null);
  fspContent: (common_strings.StringNE|null);
  createdAt: common.Instant;
}

export function makeDealTermsSource(
  input: {
    id: ferovinum_app_db.DealTermsId,
    generalHeader: (common_strings.StringNE|null),
    generalContent: (common_strings.StringNE|null),
    fspHeader: (common_strings.StringNE|null),
    fspContent: (common_strings.StringNE|null),
    createdAt: common.Instant,
  }
): DealTermsSource {
  return {
    id: input.id,
    generalHeader: input.generalHeader,
    generalContent: input.generalContent,
    fspHeader: input.fspHeader,
    fspContent: input.fspContent,
    createdAt: input.createdAt,
  };
}

const DealTermsSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.dealterms","decl":{"annotations":[{"value":{"modelName":"source__app_db.deal_terms","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.deal_terms` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealTermsId"}},"parameters":[]}},{"annotations":[],"serializedName":"generalHeader","default":{"kind":"nothing"},"name":"generalHeader","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"generalContent","default":{"kind":"nothing"},"name":"generalContent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fspHeader","default":{"kind":"nothing"},"name":"fspHeader","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fspContent","default":{"kind":"nothing"},"name":"fspContent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealTermsSource","version":{"kind":"nothing"}}};

export const snDealTermsSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.dealterms", name:"DealTermsSource"};

export function texprDealTermsSource(): ADL.ATypeExpr<DealTermsSource> {
  return {value : {typeRef : {kind: "reference", value : snDealTermsSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.dealterms.DealTermsSource" : DealTermsSource_AST
};
